import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { inject, observer } from 'mobx-react';

import withLocalization from '~/hoc/withLocalization';
import applicationRouter from '~/hoc/applicationRouter';
import OTPInput from '../../../../elements/OtpInput.js';
import Button from '../../../../components/CustomButton/CustomButton.jsx';
import CloseModalIcon from '../../../../assets/img/CloseApproveModalIcon.svg';

class Toggle2FAModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            verificationCode: '',
            isLoading: false,
        };
    }

    handleConfirm = async () => {
        const { clientStore, commonStore, authStore, t, enable_2fa, onSuccess, router } = this.props;
        const { verificationCode } = this.state;

        if (!enable_2fa && (!verificationCode || verificationCode.length < 6)) {
            commonStore.addNotification(t('Please enter the verification code'), null, 'error');
            return;
        }

        this.setState({ isLoading: true });
        try {
            const data = {
                enable_2fa,
                verificationCode: enable_2fa ? undefined : verificationCode,
                id: clientStore.currentEntity.client.id,
            };
            const response = await clientStore.update2FASettings(data);
            commonStore.addNotification(t(response.message), null, 'success');
            this.setState({ verificationCode: '', isLoading: false });
            if (enable_2fa) {
                authStore.logout();
                router.navigate('/login');
            } else {
                onSuccess();
                commonStore.setAppLoaded(true);
            }
        } catch (err) {
            this.setState({ isLoading: false });
        }
    };

    handleHide = () => {
        if (this.state.isLoading) return;
        this.setState({ verificationCode: '' });
        this.props.onHide();
    };

    render() {
        const { show, t, enable_2fa } = this.props;
        const { verificationCode, isLoading } = this.state;

        const title = enable_2fa ? `${t('Enable')} ${t('2FA')}` : `${t('Disable')} ${t('2FA')}`;
        const confirmLabel = enable_2fa
            ? (isLoading ? `${t('Enabling')}...` : `${t('Enable')} ${t('2FA')}`)
            : (isLoading ? `${t('Disabling')}...` : `${t('Disable')} ${t('2FA')}`);
        const confirmDisabled = isLoading || (!enable_2fa && verificationCode.length < 6);

        return (
            <Modal show={show} onHide={this.handleHide} size="sm" centered>
                <Modal.Header>
                    <Modal.Title className="w-100 text-center m-0">{title}</Modal.Title>
                    <img
                        src={CloseModalIcon}
                        className="cursor-pointer"
                        alt="close"
                        onClick={this.handleHide}
                    />
                </Modal.Header>
                <Modal.Body>
                    {enable_2fa ? (
                        <div>
                            <div>
                                {t('Are you sure you want to enable 2FA company-wide? All users will be logged out and will require 2FA setup.')}
                            </div>
                            <div className="text-danger mt-2 fs14">
                                {t('Note')}: {t('Admin/Pm will be required to have 2FA setup, Members can optionally skip/disable 2FA')}
                            </div>
                        </div>
                    ) : (
                        <div>
                            <p className="mb-2">
                                {t('Enter verification code from authenticator app to disable 2FA company-wide.')}
                            </p>
                            <div className="text-danger mb-2 fs14">
                                {t('Note')}: {t('All users will be logged out once 2FA is disabled')}
                            </div>
                            <label className="genericLabel mb-1 fw-bold">
                                {t('Verification Code')}<span className="red-star">*</span>
                            </label>
                            <div className="twofa-otp-layout twofa-otp-layout--left">
                                <OTPInput
                                    length={6}
                                    type="number"
                                    autoFocus
                                    onChange={(code) => this.setState({ verificationCode: code })}
                                    t={t}
                                />
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button fill dynamic_lg onClick={this.handleConfirm} disabled={confirmDisabled}>
                        {confirmLabel}
                    </Button>
                    <Button className="btn btn-outline-secondary" onClick={this.handleHide} disabled={isLoading}>
                        {t('Cancel')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default inject('clientStore', 'commonStore', 'authStore')(applicationRouter(withLocalization(observer(Toggle2FAModal))));
